import { render, staticRenderFns } from "./RoleField.vue?vue&type=template&id=17371233"
import script from "./RoleField.vue?vue&type=script&lang=js"
export * from "./RoleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports